import React from 'react';
import { animateScroll } from "react-scroll";

const Footer = () => {
  return (
    <section id="footer">
      <div className="scroll-btn" onClick={() => animateScroll.scrollToTop()}>
        <span className="iconify up-icon" data-icon="bx:bxs-chevrons-up" data-inline="false"></span>
      </div>
      <div className="footer-name">DEEPAK MAHAJAN  
        <span className="footer-desc"> <span className="footer-copyright">&copy; </span> 2020</span>
      </div>
    </section>
  )
}

export default Footer;
